import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { isChildInsideWrapper } from '@Utils';
import { KeepFocusWrapper } from '@Hooks/KeepFocus';
import withOpenCloseStuff from '@Hooks/withOpenCloseStuff';

import './SelectWrapper.scss';

export const selectWrapperMainClassName = 'select-wrapper';

export function ContentWrapper(props) {
  const { children, isOpen, forceRenderContent } = props;

  if (isOpen) {
    return <KeepFocusWrapper needKeepFocus>{children}</KeepFocusWrapper>;
  }

  if (forceRenderContent) {
    return children;
  }

  return null;
}

const SelectWrapper = React.forwardRef((props, ref) => {
  const { size, isOpen, content, children, disabled, className, forceRenderContent, contentWrapperClassName } = props;

  return (
    <div
      ref={ref}
      className={classnames(selectWrapperMainClassName, `${selectWrapperMainClassName}-${size}`, className, {
        'select-wrapper-opened': isOpen,
        'select-wrapper--disabled': disabled,
      })}>
      <div
        className={classnames('select-wrapper-children', {
          'select-wrapper-children-open': isOpen,
        })}>
        {children(props)}
      </div>
      <ContentWrapper isOpen={isOpen} forceRenderContent={forceRenderContent}>
        <div
          className={classnames('select-wrapper-content', contentWrapperClassName, {
            'select-wrapper-content-visible': isOpen,
          })}>
          {content(props)}
        </div>
      </ContentWrapper>
    </div>
  );
});

SelectWrapper.displayName = 'SelectWrapper';

SelectWrapper.defaultProps = {
  size: 'xs',
  forceRenderContent: false,
};

SelectWrapper.propTypes = {
  size: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  content: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  forceRenderContent: PropTypes.bool,
};

export const openCloseStaffSpec = {
  closeOnClick: ({ target }, props, wrapper) => !isChildInsideWrapper(target, wrapper),
};

const SelectWithOpenClose = withOpenCloseStuff(openCloseStaffSpec)(SelectWrapper);

export default SelectWithOpenClose;
